export default __webpack_public_path__ + "static/kurorty-img-5-ae3c3595447c72b6b54f1697c2ed93a2.png";